import React from 'react';
import { Container, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import LanguageToggle from '../LanguageToggle';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const showLanguageToggle = location.pathname !== '/admin' && location.pathname !== '/guide';
  const isLb1Page = location.pathname === '/lb1';
  const isQuizPage = location.pathname === '/guide';
  const noPadding = isLb1Page || isQuizPage;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: noPadding ? 'white' : 'background.default' }}>
      {showLanguageToggle && <LanguageToggle />}
      <Container maxWidth="lg" sx={{ py: noPadding ? 0 : 4, px: isQuizPage ? 0 : undefined }}>
        {children}
      </Container>
    </Box>
  );
};

export default Layout;